/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FileWiseViolations extends models.ViolationBase {
    getFixupPrototypeFunction() { return FileWiseViolations.fixupPrototype; }

    static newInstance(model: Partial<FileWiseViolations>): FileWiseViolations {
        let obj = Object.assign(new FileWiseViolations(), model);
        FileWiseViolations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FileWiseViolations>): FileWiseViolations {
        if (!model) return null;
        return FileWiseViolations.newInstance(<FileWiseViolations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FileWiseViolations) {
        if (!obj) return;

        models.FileWiseViolations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FileWiseViolations): boolean {
        if (models.ViolationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FileWiseViolations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Identifier Name for the resource for which the scanning is being done.
     */
    resource_identifier: string;

    /**
     * The violated params resulted from the scanner.
     */
    output_details: Array<string>;

    /**
     * Message available for the rule violated.
     */
    violation_message: string;

}
